'use client';

import { useSignupCTA } from '@/lib/hooks/useSignupCTA';
import ComingSoonModal from './ComingSoonModal';

export default function HomepageMidPageCTA() {
  const {
    shouldShow,
    isLoading,
    showComingSoonModal,
    handleSignupClick,
    closeModal,
  } = useSignupCTA();

  // Don't show CTA if user is already signed in
  if (!shouldShow) {
    return null;
  }

  return (
    <>
      <div className="my-12 bg-gradient-to-r from-accent-muted to-accent/5 dark:from-accent/5 dark:to-accent/[0.02] rounded-xl p-6 md:p-8 text-center border border-border">
        <h3 className="text-xl md:text-2xl font-bold text-light-text dark:text-foreground mb-3">
          Save Time. Ship Faster.
        </h3>
        <p className="text-light-text-secondary dark:text-foreground-secondary mb-4 max-w-2xl mx-auto">
          Join CTOs who save hours every week with ready-to-use frameworks, decision tools, and templates.
        </p>
        <ul className="text-sm text-light-text-secondary dark:text-foreground-secondary mb-5 space-y-1 max-w-md mx-auto text-left">
          <li className="flex items-center gap-2">
            <span className="text-accent">✓</span> Save and organize resources for quick access
          </li>
          <li className="flex items-center gap-2">
            <span className="text-accent">✓</span> Get personalized recommendations
          </li>
          <li className="flex items-center gap-2">
            <span className="text-accent">✓</span> Track your learning progress
          </li>
        </ul>
        <button
          onClick={handleSignupClick}
          disabled={isLoading}
          className="bg-accent text-accent-foreground px-6 py-3 rounded-lg font-semibold hover:bg-accent-hover transition-colors disabled:opacity-50"
        >
          Get Started Free
        </button>
        <p className="text-xs text-light-text-secondary dark:text-foreground-tertiary mt-3">
          No credit card required
        </p>
      </div>

      <ComingSoonModal
        isOpen={showComingSoonModal}
        onClose={closeModal}
        type="signup"
      />
    </>
  );
}
